// react
import type { ComponentType } from 'react';

// mui
import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { IconButtonProps } from '@mui/material/IconButton';

// components
import { Icon } from '@/components/atoms/Icon/Icon';

interface ExpandMoreProps extends IconButtonProps {
  isExpanded: boolean;
}
/**
 * ExpandMore icon button to be used in conjunction with MUI's Collapse.
 */
export const ExpandMore: ComponentType<ExpandMoreProps> = styled(
  (props: ExpandMoreProps) => {
    const { isExpanded, ...other } = props;
    return (
      <IconButton {...other}>
        <Icon icon='chevron-down' fontSize={16} />
      </IconButton>
    );
  },
)(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.short,
  }),
  variants: [
    {
      props: ({ isExpanded }) => !isExpanded,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ isExpanded }) => !!isExpanded,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));

ExpandMore.displayName = 'ExpandMore';
export default ExpandMore;
